import { Component, OnInit } from '@angular/core';
import { ShowComponent } from '@/common/component/show.component';

import { TouristGuide } from './tourist-guides.model';

@Component({
	selector: 'app-tourist-guides',
	templateUrl: './tourist-guides.component.html',
	styleUrls: ['./tourist-guides.component.css'],
})
export class TouristGuidesComponent extends ShowComponent implements OnInit {
	data: TouristGuide = {
		id: null,
		firstName: null,
		lastName: null,
		birthdate: null,
		phonePrivate: null,
		phoneBusiness: null,
		emailPrivate: null,
		emailBusiness: null,
		nearest_city: null,
		chronically_ill: 0,
		type: null,
		rate: null,
		comments: null,
		salaryComments: null,
	};
	errors = {};
	cities: Array<any> = [];
	types = [];
	apiUrlAdd = '/symfony/tourist-guide';
	selectedTabIndex = 0;
	protected itemsBeforeDataLoad = 2;
	protected parentComponent = 'touristGuides';
	private readonly tabNames = ['basic', 'rates', 'salary'];

	getApiUrl(): string {
		return '/symfony/tourist-guide/' + this.data.id;
	}

	protected override doAdd(): void {
		this.api.post(this.apiUrlAdd, this.submitConvert(this.data), (result, error) => {
			if (!error) {
				this.data.id = result.data.id;
			}
			this.afterSend(result, error);
		});
	}

	override ngOnInit(): void {
		super.ngOnInit();

		this.route.queryParams.subscribe((params) => {
			const tabParam = params['tab'];
			if (tabParam) {
				const tabIndex = this.tabNames.indexOf(tabParam);
				if (tabIndex !== -1) {
					this.selectedTabIndex = tabIndex;
				}
			}
		});
	}

	onTabChange(index: number): void {
		this.selectedTabIndex = index;
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: { tab: this.tabNames[index] },
			queryParamsHandling: 'merge',
		});
	}

	protected loadBefore() {
		this.api.get('/nearestBigCity/', (result, error) => {
			this.cities = result.data;
			this.loadData();
		});

		this.api.get('/touristGuideTypes/', (result, error) => {
			this.types = result.data;
			this.loadData();
		});
	}

	protected pageTitleGenerate(): string {
		return 'Edycja: ' + this.data.firstName + ' ' + this.data.lastName;
	}
}
